import React, { createContext, useState, useEffect, useContext } from 'react';
import i18n from '../i18n';
const LanguageContext = createContext();

// Language provider to manage language state
export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'en');

  // Change language whenever locale changes
  useEffect(() => {
    // Ensure that the language is correctly set in i18n
    i18n.changeLanguage(locale || 'en');
    localStorage.setItem('locale', locale);
  }, [locale]);

  const changeLanguage = (newLocale) => {
    setLocale(newLocale);
  };

  return (
    <LanguageContext.Provider value={{ locale, changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

// Custom hook to access language context
export const useLanguage = () => useContext(LanguageContext);
